var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconModalAcessoModulos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6.9V10H15V15C15 15 15 18 10 18C5 18 5.1 15 5.1 15L5 10H6V6.9C6 4.7 7.8 3 9.9 3H10.2C12.4 3 14 4.7 14 6.9ZM8 10H12V6.9C12 5.8 11.2 5 10.2 5H9.9C8.9 5 8 5.8 8 6.9V10ZM11 13C11 13.3557 10.8143 13.668 10.5345 13.8453L10.75 16H9.25L9.46547 13.8453C9.18571 13.668 9 13.3557 9 13C9 12.4477 9.44772 12 10 12C10.5523 12 11 12.4477 11 13Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalAcessoModulos);
export default __webpack_public_path__ + "static/media/IconModalAcessoModulos.218edeaa8fff139776423b025ebdc8fb.svg";
export { ForwardRef as ReactComponent };